<template>
  <div class="detail-tips">
    <div class="cate-list">
      <div class="cate-item" v-for="(cate, cateIndex) in detail.cate_tips" :key="cate.id" :class="{ 'is-collapsed': !isExpanded(cateIndex) }">
        <h2 class="cate-title" @click="toggleCate(cateIndex)">
          <svg class="cate-arrow" :class="{ 'is-collapsed': !isExpanded(cateIndex) }" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="9.2" fill="none" stroke="currentColor" stroke-width="1.3"></circle>
            <path d="M6.8 11.8 L10 8.6 L13.2 11.8" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"></path>
          </svg>
          <span>{{ cate.cate_name }}</span>
        </h2>
        <div class="tips-list" v-show="isExpanded(cateIndex)">
          <div class="tips-item" v-for="tip in cate.tips">
            <div class="tips-image">
              <img :src="tip.image" alt="" loading="lazy">
            </div>
            <div class="tips-container">
              <div class="tips-title">
                <p>Model</p>
                <h3>{{ tip.name }}</h3>
              </div>
              <div class="tips-content">
                <p class="ellipsis-6" v-html="tip.content"></p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "detail-tips",
  props: {
    detail: {
      type: Object,
      default: {}
    }
  },
  data(){
    return {
      // 记录每个分类是否已收起，默认全部展开
      collapsed: {}
    }
  },
  mounted() {
  },
  methods: {
    isExpanded(index){
      return this.collapsed[index] !== true
    },
    toggleCate(index){
      this.$set(this.collapsed, index, !this.collapsed[index])
    }
  }
}
</script>

<style scoped>
.detail-tips{
  width: 1400px;
  min-height: 60px;
  font-size: 20px;
  display: flex;
  padding: 0 260px;
  justify-content: space-between;
  align-items: center;
}

.detail-tips .cate-list {
  padding-bottom: 100px;
}
.detail-tips .cate-list .cate-item {}
.detail-tips .cate-list .cate-item h2 {
  font-size: 30px;
  font-weight: 500;
  margin-top: 107px;
  margin-bottom: 91px;
}
/* 分类名称前的展开/收起图标(参考商品列表页，工作尖模式为黑色) */
.detail-tips .cate-list .cate-item h2.cate-title {
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
}
.detail-tips .cate-list .cate-item .cate-arrow {
  flex: none;
  width: 18px;
  height: 18px;
  margin-right: 16px;
  color: #1B1B1B;
  transition: transform .3s;
}
.detail-tips .cate-list .cate-item .cate-arrow.is-collapsed {
  transform: scaleY(-1);
}
.detail-tips .cate-list .cate-item.is-collapsed h2 {
  margin-bottom: 0;
}
.detail-tips .cate-list .cate-item .tips-image {
  width: 670px;
  height: 270px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
  border-radius: 8px;
  overflow: hidden;
}
.detail-tips .cate-list .cate-item .tips-image img {
  width: 100%;
}
.detail-tips .cate-list .cate-item .tips-container {
  width: 668px;
  margin-left: 62px;
}
.detail-tips .cate-list .cate-item .tips-container .tips-title {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #B5B5B5;
  padding: 16px 0 25px 35px;
}
.detail-tips .cate-list .cate-item .tips-container .tips-title p {
  color: #7D7D7D;
  font-size: 16px;
  margin-right: 57px;
}
.detail-tips .cate-list .cate-item .tips-container .tips-title h3 {
  color: #1C1B1B;
  font-size: 24px;
  font-weight: 500;
}

.detail-tips .cate-list .cate-item .tips-container .tips-content {
  padding: 31px 31px 0 32px;
  color: #7D7D7D ;
  font-size: 14px;
  line-height: 30px;
}
.ellipsis-6 {
  display: -webkit-box;
  //-webkit-box-orient: vertical;
  //-webkit-line-clamp: 6;
  //overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: calc(1.5em * 6);
  font-size: 14px!important;
  white-space: pre-wrap;
}


.detail-tips .cate-list .cate-item .tips-list .tips-item {
  display: flex;
  margin-bottom: 60px;
}
</style>

<style>
.detail-tips .cate-list .cate-item .tips-container .tips-content p {
  font-size: 14px!important;
}
</style>
